// Current, grantable plans (shown in the admin tier dropdown). Legacy plans are intentionally
// excluded so they can't be assigned to new users — but they remain in PLAN_LABEL/PLAN_CLS so
// grandfathered orgs still display correctly (see UsersTab, which appends a user's own legacy plan).
export const PLAN_OPTS = ["personal", "solo", "group", "smallbiz", "internal"];

// Legacy plan keys kept only for displaying grandfathered subscribers, never offered for new grants.
export const LEGACY_PLANS = ["starter", "pro", "business", "enterprise"];

export const PLAN_LABEL = {
  personal: "Free", solo: "Solo", group: "Group", smallbiz: "Team", internal: "Unlimited (Internal)",
  starter: "Starter (legacy)", pro: "Professional (legacy)", business: "Business (legacy)", enterprise: "Enterprise (legacy)",
};

export const PLAN_CLS = {
  personal: "text-zinc-300",
  solo: "text-emerald-400",
  group: "text-cyan-400",
  smallbiz: "text-amber-400",
  internal: "text-fuchsia-400",
  starter: "text-emerald-400",
  pro: "text-cyan-400",
  business: "text-blue-400",
  enterprise: "text-amber-400",
};

export const fmtDate = (iso) => {
  if (!iso) return "N/A";
  try { return new Date(iso).toLocaleDateString(undefined, { year: "numeric", month: "short", day: "numeric" }); }
  catch { return "N/A"; }
};

// ISO string -> value for <input type="datetime-local"> in local tz
export const isoToLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return "";
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
};
